import { render, staticRenderFns } from "./blackUser.vue?vue&type=template&id=3230d3d2&"
import script from "./blackUser.vue?vue&type=script&lang=js&"
export * from "./blackUser.vue?vue&type=script&lang=js&"
import style0 from "./blackUser.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports